// recon-bank-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'rcb.match.matched': 'Matchet mot bokføring',
  'rcb.match.suggested': 'Foreslått match',
  'rcb.match.review': 'Til manuell kontroll',
  'rcb.match.unmatchedBank': 'Umatchet banktransaksjon',
  'rcb.match.manual': 'Lagt til manuelt',
  'rcb.match.excluded': 'Holdt utenfor',
  'rcb.match.noBankMatch': 'Bokføring uten banktreff',
  'rcb.status.new': 'Ikke behandlet',
  'rcb.status.suggested': 'Forslag venter',
  'rcb.status.review': 'Til kontroll',
  'rcb.status.booked': 'Bokført',
  'rcb.status.approved': 'Godkjent',
  'rcb.status.private': 'Privat',
  'rcb.status.operating': 'Drift',
  'rcb.status.ignored': 'Ignorert',
  'rcb.status.manual': 'Lagt til manuelt',
  'rcb.line.fallback': 'Banklinje',
  'rcb.source.private': 'Privatkonto',
  'rcb.source.statement': 'Bankutskrift',
  'rcb.source.none': 'Ingen utskrift',
  'rcb.cov.none': 'Ingen bankutskrift for perioden',
  'rcb.cov.missingRange': 'mangler fra {from} til {to}',
  'rcb.cov.and': '{first} og {second}',
  'rcb.check.coverage': 'Bankgrunnlaget dekker hele perioden',
  'rcb.check.balance': 'Bokført saldo stemmer med banksaldo',
  'rcb.check.notBooked': 'Alle banklinjer er bokført',
  'rcb.check.review': 'Ingen linjer står til manuell kontroll',
  'rcb.check.missingVoucher': 'Utbetalinger har bilag',
  'rcb.check.duplicate': 'Mulige duplikater er vurdert',
  'rcb.check.noBankMatch': 'Alle bokføringer på bankkontoene har en banklinje',
  'rcb.check.staleTransit': 'Ingen gamle bokføringer venter på banken',
  'rcb.check.internal': 'Interne overføringer går opp',
});
